<template>

    <main id="machine-sheet-showroom" v-if="displayContent">
      <template v-if="(pictures.length+videos.length) > 1 ">


        <div class="showroom-container" >
            <sheet-block-picture-video-showroom :pictures="filteredPictures" :videos="videos" v-if="showroomDisplayable" />
        </div>
        <div class="wrapper">
            <div class="titled-container walkaround-container" v-if="walkaroundVideo">
                <h2 class="title is-2">
                    {{ $t("walkaround") }}
                </h2>
                <a
                        class="video-block"
                        :style="`background-image: url(${walkaroundVideo.thumbnail});`"
                        data-mediabox="walkaround"
                        :href="walkaroundVideo.embed"
                        :data-width="lightboxVideoWidth"
                        :data-height="lightboxVideoHeight"
                        aria-label="Walkaround video"
                        @click="enableBlur()"
                >
                    <span class="icon-play"></span>
                </a>
            </div>

        </div>
      </template>
      <template v-else>
        <div class="content-available-soon">
          {{ $t('content_available_soon') }}
        </div>
      </template>
    </main>

</template>

<script>
import {mapGetters, mapState} from 'vuex'
    import speedTrackingMixins from "@/common/mixins/speedTracking"
    import playlistService from "@/services/youtube/playlist"
    import videoService from "@/services/youtube/video"

    import SheetBlockPictureVideoShowroom from "@/components/SheetBlock/SheetBlockPictureVideoShowroom";
    import productService from "../../../services/serli/product";

    export default {
        name: 'MachineShowroomView',
        mixins: [
            speedTrackingMixins
        ],
        components: {
            SheetBlockPictureVideoShowroom,
        },
        data() {
            return {
                displayContent: false,
                showroomDisplayable: false,
                pictures: [],
                videos: [],
                walkaroundVideo: null,
                reduceRisksVideos: [],
            }
        },
        computed: {
            ...mapState({
                productDatas: state => state.sheet.productDatas,
                selectedCategory : state => state.searchMachines.category,
                marketFilter: state => state.searchMachines.marketFilter
            }),

            ...mapGetters({
              localeKebabFormat: 'settings/localeKebabFormat'
            }),

          marketContext() {
            let market='';
            if(this.selectedCategory) {
              switch (this.selectedCategory.code) {
                case 'telehandlers' :
                  market='CONS'
                  break
                case 'agricultural_telehandlers' :
                  market='AGRI'
                  break
              }
            }
            if(this.marketFilter) market=this.marketFilter.code
            return market
          },

          filteredPictures() {
            let pictures=[];
            //déterminer le market
            if(this.marketContext!=='') {
              this.pictures.forEach((picture,index) => {
                if((picture.markets && picture.markets.includes(this.marketContext)) || index===0 || !picture.markets) pictures.push(picture)
              })
              //Ajouter conditionnel si pictures.length===0 ?
              return pictures
            } else return this.pictures;
          }
        },
        created(){
            this.startLoading();
            this.getAssetsData();
        },
        methods: {
          loadData() {
              let promisesArray = [
                this.getYoutubeVideo(),
                this.fetchMainVisual(),
                this.fetchAllShowroomMedias(),
              ];

              this.speedTrackingShowroom = new Date().getTime();

              Promise.all(promisesArray).then(() => {
                if( this.pictures.length > 0 || this.videos.length > 0)
                  this.showroomDisplayable = true;

                this.stopLoading()
                this.displayContent = true;

                let promisesArrayDocuments = [
                  this.fetchWalkaround(),
                  this.fetchReduceRisks(),
                ];

                this.speedTrackingDocuments = new Date().getTime();
                return Promise.all(promisesArrayDocuments);

              }).finally(() => {
                this.$nextTick(() => {
                  if(this.walkaroundVideo)
                    this.$root.wamediabox.bind(document.querySelector(".video-block"));
                  if(this.reduceRisksVideos.length > 0)
                    this.$root.wamediabox.bindAll(document.querySelector(".reduce-risks-container"));
                })
              });

              this.speedTrackingShowroomTrigger('machine', this.productDatas.identifier, this.productDatas.values.reference_name);
          },
          async getAssetsData() {
            if (!this.productDatas.assets.length) {
              // this.startLoading();
              // console.log('get data')
              await productService.getAssets(this.productDatas.identifier, {locale: this.localeKebabFormat})
                  .then(response => {
                     console.log(response.data)
                    let productDatasStored = this.productDatas;
                    productDatasStored.assets = response.data.data;

                    this.$store.commit('sheet/setProductDatas', productDatasStored);
                  })
                  .finally(() => this.loadData());
            } else this.loadData()
          },

            async getYoutubeVideo(){
                let youtubeVideos = [
                    'youtube_video',
                    'youtube_range',
                    'youtube_other',
                ]

                for(const youtubeVideo of youtubeVideos) {
                    if(this.productDatas.values[youtubeVideo]) {
                      //correctif pour mauvaise qualif akeneo
                      if(this.productDatas.values[youtubeVideo].code.indexOf('&list=')>1) this.productDatas.values[youtubeVideo].code=this.productDatas.values[youtubeVideo].code.split('&list=')[1]
                      if(this.productDatas.values[youtubeVideo].code.indexOf('&')>1) this.productDatas.values[youtubeVideo].code=this.productDatas.values[youtubeVideo].code.split('&')[0]

                      let url = 'https://www.youtube.com/embed/';
                      if (this.productDatas.values[youtubeVideo].code.length > 11) {
                        const response=await playlistService.getVideos(this.productDatas.values[youtubeVideo].code, {withDetails: true})
                        for (const video of response.data.data) {
                          this.videos.push({
                            type: 'video',
                            src: 'https://img.youtube.com/vi/' + video.code + '/sddefault.jpg',
                            embed: video.embed,
                            thumb: 'https://i.ytimg.com/vi/' + video.code + '/hqdefault.jpg',
                          })
                        }
                      } else {
                        url = url + this.productDatas.values[youtubeVideo].code + '?autoplay=1';
                        this.videos.push({
                          type: 'video',
                          src: 'https://img.youtube.com/vi/' + this.productDatas.values[youtubeVideo].code + '/sddefault.jpg',
                          embed: url,
                          thumb: 'https://i.ytimg.com/vi/' + this.productDatas.values[youtubeVideo].code + '/hqdefault.jpg',
                        })
                      }
                    }
                }
            },
            async fetchAllShowroomMedias(){
                let mediasAttributes = [
                    'application',
                    'studio',
                    'detail',
                ];

                for(const mediasAttribute of mediasAttributes)
                    await this.fetchShowroomMedias(mediasAttribute)
            },
            async fetchWalkaround(){
                if(this.productDatas.values['youtube_walkaround'])
                    return videoService.get(this.productDatas.values['youtube_walkaround'].code).then((response) => this.walkaroundVideo = response.data.data)
            },
            fetchReduceRisks(){
                if(this.productDatas.values['youtube_reduce_program']) {
                  //Correctif pour mauvaise qualification
                  if (this.productDatas.values['youtube_reduce_program'].code.indexOf('&list=') > 1) this.productDatas.values['youtube_reduce_program'].code = this.productDatas.values['youtube_reduce_program'].code.split('&list=')[1]
                  return playlistService.getVideos(this.productDatas.values['youtube_reduce_program'].code, {withDetails: true}).then((response) => {
                    if (response.data.data)
                      this.reduceRisksVideos = response.data.data
                  })
                }
            },
        }
    }
</script>


<style lang="scss">
    #machine-sheet-showroom {
        padding-top: 35px;
        padding-bottom: 40px;

        .showroom-container {
            padding-left: 30px;

            @media #{$mq_phone} {
                padding-left: 20px;
                padding-right: 20px;
            }
        }


    }
</style>

